<template>
  <v-main>
    <v-container>
      <v-row>
        <v-col class="text-center">
          <v-progress-circular
            v-if="isLoading && orders.length === 0"
            indeterminate
          />
        </v-col>
      </v-row>

      <v-container v-if="!isLoading && !orders.length">
        <h1 class="text-center">
          {{ errorMessage }}
        </h1>
      </v-container>

      <v-container v-else>
        <v-row
          v-if="!isLoading"
          justify="center"
        >
          <v-col class="grey lighten-4">
            <order-overview
              class="mb-8"
              :sofie-id="sofieId"
              :ship-to-address-info="shipToAddressInfo"
            />
            <v-card
              v-for="(order, index) in orders"
              :key="index"
              class="mb-1"
              elevation="3"
            >
              <order-card :order="order" />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-main>
</template>
<script lang="ts">
import { OrderNumber, SofieShipToAddress, TrackingInfo } from "@/types/types";

import { defineComponent } from "vue";
import OrderCard from "@/components/sofie/OrderCard.vue";
import OrderOverviewVue from "@/components/sofie/OrderOverview.vue";

type Data = {
  errorMessage: string;
  isLoading: boolean;
  sofieId: string;

  orders: Array<TrackingInfo>;

  shipToAddressInfo: SofieShipToAddress;
  orderId: OrderNumber;
};

export default defineComponent({
  name: "TrackingDetail",
  components: {
    "order-card": OrderCard,
    "order-overview": OrderOverviewVue,
  },
  data: function (): Data {
    return {
      isLoading: false,

      sofieId: "",
      shipToAddressInfo: { Address: "", City: "", State: "", Zip: "" },
      orderId: 0,

      errorMessage: "Unable to locate this tracking number.",
      orders: new Array<TrackingInfo>(),
    };
  },
  created: function () {
     const { id } = this.$route.params;
    this.sofieId = id;

    this.getTrackingInfo(id);

    setInterval(() => {
      this.getTrackingInfo(id);
    }, 300000);
  },
  methods: {
    getTrackingInfo: function (orderReference: string) {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      this.isLoading = true;
      this.$apiClient.GET('/sofie/{shipToCode}', {
        params: {
          path: {
            shipToCode: orderReference
          }
        }
      }).then((response) => {
          if (response.data && response.data.length > 0) {
            const ordersToArrange = response.data;

            const ordersInProgress = ordersToArrange.filter(orderToArrange => orderToArrange.PickupDateTime && !orderToArrange.DeliveryDateTime).sort((orderA, orderB) => new Date(orderA.Eta ?? Date.now()).valueOf() - new Date(orderB.Eta ?? Date.now()).valueOf());
            const ordersNotStarted = ordersToArrange.filter(orderToArrange => !orderToArrange.PickupDateTime && !orderToArrange.DeliveryDateTime);
            const completedOrders = ordersToArrange.filter(orderToArrange => orderToArrange.PickupDateTime && orderToArrange.DeliveryDateTime);

            this.orders = ordersInProgress.concat(completedOrders, ordersNotStarted);

            this.orderId = this.orders[0].OrderID;
            const { Address, City, State, Zip } = this.orders[0];
            Object.assign(this.shipToAddressInfo, { Address, City, State, Zip });

            this.isLoading = false;
          } else {
            this.orders = [];
          }
          this.isLoading = false;

          this.$nextTick(() => {
            this.$nextTick(() => {
              window.scrollTo({ top: scrollPosition, behavior: 'instant' });
              setTimeout(() => {
                window.scrollTo({ top: scrollPosition, behavior: 'instant' });
              }, 100);
            });
          });
        },
        () => {
          this.isLoading = false;
          this.$nextTick(() => {
            this.$nextTick(() => {
              window.scrollTo({ top: scrollPosition, behavior: 'instant' });
              setTimeout(() => {
                window.scrollTo({ top: scrollPosition, behavior: 'instant' });
              }, 100);
            });
          });
        }
      );
    },
    getLaterDateTime(dateTimeStringOne: string, dateTimeStringTwo: string) {
      return dateTimeStringOne > dateTimeStringTwo ? dateTimeStringOne : dateTimeStringTwo;
    },
  },
});
</script>